export const PayReason = {
  Ch_PartyFee: 1, // 파티 요금 결제(시작일)
  Ch_PartyFee_PayDay: 2, // 파티 요금 결제(정산일)
  Ch_PenaltyFee: 3, // 파티 위약금 결제
  Ch_GuaranteeFee: 4, // 파티 보증금 거치
  Ch_eat_n_run: 5, // 먹튀
  Ch_PartyFee_Before: 6, // 예정 파티 즉시 결제
  Ch_PartyFee_Proxy: 8, // 프록시 파티 결제 
  // -------------------------------------------------
  Re_EndCompensation: 50, // 파티 리워드(종료 리워드, 중도 탈퇴 보상금) 적립 (파티장)
  Re_EndRew: 51, // 파티 종료 적립(파티원)
  Re_Compensation: 52, // 파티 누적 보상금 적립(중도 해산 && 무책 케이스의 탈퇴 보상금) - 파티장
  Re_PartyFee_PayDay: 53, // 파티 요금 적립(정산일)
  Re_EndRew_Exit: 54, // 파티 종료 적립(중도 탈퇴)
  Re_EndRew_Break: 55, // 파티 종료 적립(중도 해산)
  Re_PartyFee_PartyEnd: 56, // 파티 요금 적립 (종료 파티)
  Re_PartyFee_PartyEnd_Sset: 57, // 파티 요금 적립 (종료 파티 - 일몰 종료) - 파티원
  Re_No_Reason_Exit: 58, // 무책 탈퇴
  Re_1_Exit: 59, // 무책 일할 탈퇴
  Re_No_Reason_Broken: 60, // 무책 해산
  Re_1_Broken: 61, // 무책 일할 해산
  Re_EndCompensation_Sset: 62, // 파티 리워드(종료 리워드, 중도 탈퇴 보상금) 적립 (일몰) - 파티장
  Re_EndRew_Before_Exit: 63, // 예정 탈퇴/해산 (즉시 결제)
  Re_EndRew_No_Reason_Break: 64, // 파티 종료 적립(무책 일할 해산)
  Re_Youtube_Broken: 65, // 유튜브 일할 환불
  Re_Youtube_Broken_PG: 66, // 유튜브 일할 환불 PG

  // -------------------------------------------------
  WithDraw: 101, // 인출
  Admin_Cut_Money: 102, // 링키드 머니 차감(어드민)
  Admin_Charge_Money: 103, // 링키드 머니 충전(어드민)
};

export const LPointReason = {
  LP_Plus: 101 || 102 || 103, // 포인트 적립
  LP_Refund: 104, // 포인트 환불
  LP_Use: 201, // 포인트 사용
  LP_ToMoney: 202, // 링키드 머니로 전환
  LP_End: 203, // 포인트 만료
  LP_Admin_Cut: 204, // 포인트 삭감 (어드민)
};

// 파티 상태
export const PState = {
  hidden: 100, // 숨기기
  using: 1, // 정상
  ended: 0, // 종료
  breaking: 2, // 해산 대기
  broken: 3, // 해산
};

// 파티 멤버 상태
export const PMState = {
  normal: 0,
  exitReady: 1,
  exited: 2,
  nopaid: 3,
};

// 파티의 현재 상세상태 구하기.
export const CPState = {
  CPS_None: 0,
  CPS_Before: 1, // 예정
  CPS_Requested: 2, // 요청
  CPS_ExitReady: 3, // 탈퇴 예정
  CPS_Exited: 4, // 탈퇴
  CPS_BreakReady: 5, // 해산 예정
  CPS_Broken: 6, // 해산
  CPS_Ended: 7, // 종료
  CPS_Using: 8, // 정상 운영
  CPS_Expelled: 9, // 넷플릭스 추방하기

  CPS_Sunset_to_Come: 10, // 일몰 예정
  CPS_Sunset_Ended: 11, // 일몰 종료

  CPS_no_reason_Exit: 20, // 무책 탈퇴            -> Admin 에서 fState
  CPS_1_Exit: 21, // 일할 무책 탈퇴       -> Admin 에서 fState
  CPS_reward_1_Exit: 22, // 보상 일할 무책 탈퇴  -> Admin 에서 fState
  CPS_Exit_Admin: 23, // 어드민 유책 탈퇴  -> Admin 에서 fState
  CPS_pre_no_reason_Exit: 24, // 예정 무책 탈퇴       -> Admin 에서 fState

  CPS_no_reason_broken: 30, // 무책 해산            -> Admin 에서 fState
  CPS_1_broken: 31, // 일할 무책 해산       -> Admin 에서 fState
  CPS_eat_n_run: 32, // 먹튀                -> Admin 에서 fState
  CPS_Broken_Admin: 33, // 어드민 유책 해산                -> Admin 에서 fState
  CPS_pre_no_reason_broken: 34, // 예정 무책 해산    -> Admin 에서 fState

  CPS_Before_join_fail: 41, // 예정 가입 실패       -> 체크가 제일 애매함.
  CPS_Before_Exited: 42, // 예정 탈퇴            -> 예정 상태일 때 탈퇴를 하면 fState에
  CPS_Before_Broken: 43, // 예정 해산            -> 예정 상태일 때 해산을 하면 fstate

  CPS_Requested_End: 51, // 요청 종료            -> Request state = 1
  CPS_Requested_Cancel: 52, // 요청 취소            -> Request state = 2 /requestcancel 일 경우
};

// 시즌 이벤트 상태
export const SeasonEventType = {
  SE_Normal: 0,
  SE_Christmas: 1,
  SE_NewYear2022: 2,
  SE_Christmas_2022: 3,
};

export const Locale = {
  kokr: "kokr",
  koen: "koen",
};

//선셋 타입
export const SSetType = {
  PRX_INC: 1, // 요금 인상
  PRX_CHANGE: 2, // 요금 정책 변경
  IVT_CHANGE: 3, // 초대 방식 변경
  SVC_CHANGE: 4, // 서비스 상세 항목 변경
  ETC: 10000, // 기타
};

//넷플릭스 추가공유 파티원 상태
export const NetflixExtraGuestStatus = {
  NEW: 1,
  NEW_RegReady: 2,
  NEW_RegComplete: 3,
  NEW_RegComplete_Manual: 4,
  SECONDHAND_PwResetNeed: 5,
  SECONDHAND_Normal: 6,
  SECONDHAND_Normal_Manual: 7,
};

// 구독권 무료 상태
export const SubsFreeType = {
  FREE_ALL: 1, //subsfee + deposit = 0
  FREE_SUBSFEE: 2, //subsfee  = 0
  FREE_DEPOSIT: 3, //deposit = 0
  NO_FREE: 4,
};
